import { render, staticRenderFns } from "./TraceDetail.vue?vue&type=template&id=554b7269&scoped=true"
import script from "./TraceDetail.vue?vue&type=script&lang=js"
export * from "./TraceDetail.vue?vue&type=script&lang=js"
import style0 from "./TraceDetail.vue?vue&type=style&index=0&id=554b7269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b7269",
  null
  
)

export default component.exports